export default "__VITE_ASSET__B$epx4uT__"